<template>
    <div class="cart-container lx-h100">
        <full-con isHidden>
            <div slot="full" class="lx-h100 lx-flex-column">
                <el-row class="lx-flex-shrink-0">
                    <el-col :span="12" class="row-left">
                        <el-row>
                            <el-col :span="4" class="Accessories-title">{{ $t('createOrder.createOrder2') }}: </el-col>
                            <el-col :span="20" class="Accessories">
                                <el-row>
                                    <el-col :span="6"> {{ $t('createOrder.createOrder3') }}： </el-col>
                                    <el-col :span="6">
                                        {{ userInfo.paperLabelCount }}
                                    </el-col>
                                    <el-col :span="6"> {{ $t('createOrder.createOrder4') }}： </el-col>
                                    <el-col :span="6">
                                        {{ userInfo.washingMark }}
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="6"> {{ $t('createOrder.createOrder5') }}： </el-col>
                                    <el-col :span="6">
                                        {{ userInfo.signCount }}
                                    </el-col>
                                    <el-col :span="6"> {{ $t('createOrder.createOrder6') }}： </el-col>
                                    <el-col :span="6">
                                        {{ userInfo.accessoriesCount }}
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="12" class="row-right">
                        <div class="lx-flex-row-end" style="padding-top: 10px">
                            <el-button class="search-btn btn-blue" @click="isVisiable = true">{{$t('createOrder.createOrder101')}}</el-button>
                            <span style="display: inline-block; padding-right: 20px; padding-top: 6px"
                                class="">{{ $t('createOrder.createOrder7') }}：{{ userInfo.balance }}元</span>
                            <el-button class="form-btn btn-green" @click="toRecharge">{{ $t('createOrder.createOrder8') }}</el-button>
                            <el-button class="search-btn btn-blue" @click="downloadTemplate">{{ $t('address.address42') }}</el-button>
                            <!-- 批量上传 -->
                            <batch-upload @success="onBatchImport"></batch-upload>
                        </div>
                    </el-col>
                </el-row>
                <div class="table-container lx-flex-grow-1 lx-hidden lx-pt10 lx-relative">
                    <el-form v-loading="isSpin" :model="formInfo" ref="addForm" label-width="auto" :style="{height: `calc(100% - 50px)`}">
                        <lx-table ref="cartGoodsTable" :list="tableData" isSelectTable border showScrollbar :rowKey="randomKey" :emptyText="$t('select.select24')" :isCheckedAll="isCheckedAll" @changeSelectAll="onChangeSelectAll" :header-cell-style="tableStyle.headerStyle" isCustomSelect :reserveSelection="true" :cell-style="tableStyle.cellStyle" @selectChange="doSelectionChange">
                            <el-table-column :label="$t('createOrder.createOrder10')" width="98">
                                <template v-slot="scope">
                                    <el-button class="list-btn btn-red" @click="doDelete(scope.row, scope.$index)">{{ $t('delete') }}</el-button>
                                    <el-button class="list-btn btn-green" @click="doCopy(scope.row, scope.$index)">{{ $t('laund.laund8') }}</el-button>
                                </template>
                            </el-table-column>
                            <!-- 淘宝链接 -->
                            <el-table-column prop="taobaoUrl" :label="$t('createOrder.createOrder12')" min-width="120">
                                <template slot-scope="scope">
                                    <el-form-item class="no-label">
                                        <el-input v-model="scope.row.taobaoUrl" size="small" @blur="blurTaobaoUrl(scope.row.taobaoUrl, scope.$index)"
                                        clearable></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- 商品信息 -->
                            <el-table-column :label="$t('createOrder.createOrder13')" min-width="260">
                                <template slot-scope="scope">
                                    <el-row>
                                        <el-form-item class="lx-label-ml-0" :label="$t('createOrder.createOrder116')">
                                            <el-input v-model="scope.row.goodsName" size="small" clearable></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item class="lx-label-ml-0" :label="$t('createOrder.createOrder15')" :prop="'tableData.' + scope.$index + '.goodsCount'" :rules="rules[scope.$index].goodsCount">
                                                <el-input v-model="scope.row.goodsCount" size="small" type="number" @change="onInputChange" @mousewheel.native.prevent></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item class="lx-label-ml-0" :label="$t('createOrder.createOrder16')" :prop="'tableData.' + scope.$index + '.price'" :rules="rules[scope.$index].price">
                                                <el-input v-model="scope.row.price" size="small" type="number" @change="onInputChange" @mousewheel.native.prevent></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item class="lx-label-ml-0" :label="$t('createOrder.createOrder17')" :prop="'tableData.' + scope.$index + '.colour'" :rules="rules[scope.$index].colour">
                                                <el-input v-model="scope.row.colour" size="small"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item class="lx-label-ml-0" :label="$t('createOrder.createOrder18')">
                                                <el-input v-model="scope.row.goodsSize" size="small"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-form-item class="lx-label-ml-0" :label="$t('createOrder.createOrder19')" :prop="'tableData.' + scope.$index + '.goodsNumber'">
                                            <el-input v-model="scope.row.goodsNumber" size="small"></el-input>
                                        </el-form-item>
                                    </el-row>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('createOrder.createOrder112')" width="150">
                                <template slot-scope="scope">
                                    <!-- 国内运单号 -->
                                    <el-form-item class="no-label" :label="$t('orderList.orderList5')"
                                    :prop="'tableData.' + scope.$index + '.trackingNumber'"
                                    :rules="!scope.row.freightDisabled ? {} : rules[scope.$index].trackingNumber">
                                        <el-input v-model="scope.row.trackingNumber" maxlength="50" size="small" :disabled="!scope.row.freightDisabled"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- 图片 -->
                            <el-table-column prop="pictureUrl" :label="$t('feedback.feedback9')" width="110">
                                <template v-slot="scope">
                                    <img v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0" :src="scope.row.pictureUrl" alt="" style="width: 50px; height: 50px" />
                                    <el-upload class="avatar-uploader" v-if="!scope.row.pictureUrl || scope.row.pictureUrl.length === 0" action="/" :show-file-list="false"
                                        :http-request="uploadImg" accept=".jpg,.png,.jpeg" :limit="1" :before-upload="beforeImgUpload">
                                        <el-button class="list-btn btn-blue" ref="uploadImg" @click="beforeUploadImg(scope.$index)">{{ $t('createOrder.createOrder20') }}</el-button>
                                    </el-upload>
                                    <el-button v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0" class="list-btn btn-red lx-block"  @click="delImg(scope.row, scope.$index)">{{ $t('delete') }} </el-button>
                                </template>
                            </el-table-column>
                            <!-- pdf -->
                            <el-table-column prop="pdfName" :label="$t('createOrder.createOrder22')" width="110">
                                <template slot-scope="scope">
                                    <el-upload v-if="!scope.row.pdfName" action="/" :http-request="uploadVideo"
                                        :before-upload="beforePdfUpload" accept=".pdf,.ai" :limit="1" :show-file-list="false">
                                        <el-button class="list-btn btn-blue" ref="uploadVideo" @click="beforeUploadVideo(scope.$index)">
                                        {{ $t('createOrder.createOrder20') }}</el-button>
                                    </el-upload>
                                    <span v-if="scope.row.pdfName">{{ scope.row.pdfName }}</span>
                                    <el-button v-if="scope.row.pdfName && scope.row.pdfName.length > 0" class="list-btn btn-red" @click="delPdf(scope.row)">{{ $t('delete') }} </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="agentFlag" :label="$t('createOrder.createOrder99')" width="110">
                                <template slot-scope="scope">
                                    <!-- 代为购买 -->
                                    <el-form-item class="no-label line-height-30" :prop="'tableData.' + scope.$index + '.agentFlag'">
                                        <label>{{ $t('createOrder.createOrder21') }}</label>
                                        <el-select @change="agentFlagchange(scope.row.agentFlag, scope.$index,scope.row)" v-model="scope.row.agentFlag" :placeholder="$t('address.address38')" size="small">
                                            <el-option v-for="item in agentFlagOption" :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fnsku" :label="$t('createOrder.createOrder23')" min-width="260">
                                <template slot-scope="scope">
                                    <!-- FBA/YFF/ZOZO/RSL -->
                                    <el-row>
                                        <el-form-item class="lx-label-ml-0 line-height-30" :prop="'tableData.' + scope.$index + '.orderType'">
                                            <el-select v-model="scope.row.orderType" :placeholder="$t('address.address38')" size="small"
                                                @change="orderTypeChange(scope.row.orderType, scope.$index,scope.row)">
                                                <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-row>
                                  <div v-if="scope.row.orderType == 5 || scope.row.orderType == 6">
                                    <el-row>
                                      <el-form-item class="lx-label-ml-0 line-height-30" :label="'是否同捆'"
                                                    :prop="'tableData.' + scope.$index + '.tongkun'"
                                                    :rules="rules[scope.$index].tongkun">
                                        <el-select size="small" v-model="scope.row.tongkun" placeholder="请选择">
                                          <el-option label="是" value="1"></el-option>
                                          <el-option label="否" value="0"></el-option>
                                        </el-select>
                                      </el-form-item>
                                    </el-row>
                                    <el-row>
                                      <el-form-item class="lx-label-ml-0 line-height-30" :label="'收货地址'"
                                                    :prop="'tableData.' + scope.$index + '.address'"
                                                    :rules="rules[scope.$index].address">
                                        <div style="display: flex; align-items: center;margin-top: 2px;">
                                          <el-input v-model="scope.row.address" size="small"
                                                    :placeholder="'请输入地址'"
                                                    :disabled="true"></el-input>
                                          <el-button type="primary" size="small"
                                                     @click="selectAddress(scope.row,scope.$index)"
                                          >{{ $t('createOrder.createOrder32') }}</el-button>
                                        </div>
                                      </el-form-item>
                                    </el-row>
                                  </div>
                                    <div v-else>
                                      <el-row>
                                        <el-form-item class="lx-label-ml-0 line-height-30" :label="scope.row.skuLabel?scope.row.skuLabel:'コード'"
                                                      :prop="'tableData.' + scope.$index + '.fnsku'"
                                                      :rules="scope.row.fnskuDisabled ? rules[scope.$index].fnsku : {}">
                                          <el-input v-model="scope.row.fnsku" :placeholder="scope.row.skuPlaceolder" size="small" clearable
                                                    :disabled="!scope.row.fnskuDisabled"></el-input>
                                        </el-form-item>
                                      </el-row>
                                      <el-row>
                                        <el-form-item class="lx-label-ml-0 line-height-30" :label="$t('createOrder.createOrder113')"
                                                      :prop="'tableData.' + scope.$index + '.goodsNameCus'"
                                                      :rules="scope.row.fnskuDisabled ? rules[scope.$index].goodsNameCus : {}">
                                          <el-input maxlength="200" v-model="scope.row.goodsNameCus" size="small" clearable
                                                    :placeholder="'店舗商品表示名を入力してください'"
                                                    :disabled="!scope.row.fnskuDisabled"></el-input>
                                        </el-form-item>
                                      </el-row>
                                      <el-row>
                                        <el-form-item class="lx-label-ml-0 line-height-30" label="ASIN"
                                                      :prop="'tableData.' + scope.$index + '.asin'"
                                                      :rules="scope.row.fnskuDisabled ? rules[scope.$index].asin : {}">
                                          <el-input v-model="scope.row.asin" size="small" clearable :disabled="!scope.row.fnskuDisabled"></el-input>
                                        </el-form-item>
                                      </el-row>
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- 检品选项 -->
                            <el-table-column prop="checkProjectArray" :label="$t('createOrder.createOrder25')" min-width="120">
                                <template slot-scope="scope">
                                <el-form-item class="no-label" :prop="'tableData.' + scope.$index + '.checkProjectArray'" clearable>
                                    <el-select multiple v-model="scope.row.checkProjectArray" :placeholder="$t('address.address38')"
                                    size="small" @change="configCheckChanged(scope.row)">
                                        <el-option v-for="(item, index) in inspectionOption" :key="index" :label="item.name" :value="item.nameCd">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="inspectionFileName" :label="$t('createOrder.createOrder95')" width="110">
                                <template slot-scope="scope">
                                    <el-upload v-if="scope.row.inspectionFileName.length == 0" action="/" :http-request="uploadFile"
                                        :before-upload="beforeFileUpload" accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.jpg,.jpeg,.png,.gif"
                                        :limit="1" :show-file-list="false">
                                        <el-button class="list-btn btn-blue" ref="uploadFile" @click="beforeUploadFile(scope.$index)">
                                        {{ $t('createOrder.createOrder20') }}</el-button>
                                    </el-upload>
                                    <span v-if="scope.row.inspectionFileName">{{ scope.row.inspectionFileName }}</span>
                                    <el-button v-if="scope.row.inspectionFileName && scope.row.inspectionFileName.length > 0" class="list-btn btn-red"
                                        @click="delFile(scope.row)">{{ $t('delete') }} </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="laundryLabelId" :label="$t('createOrder.createOrder26')" width="120">
                                <template slot-scope="scope">
                                    <el-form-item class="mini-label" :prop="'tableData.' + scope.$index + '.laundryLabelId'" label=' ' :rules="scope.row.isTempDisabled ? rules[scope.$index].laundryLabelId : {}">
                                        <el-select v-model="scope.row.laundryLabelId" :placeholder="$t('address.address38')" size="small" clearable
                                            :disabled="!scope.row.isTempDisabled">
                                            <el-option v-for="item in laundryLabelOption" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="customerRemark" :label="$t('createOrder.createOrder111')" width="100">
                                <template slot-scope="scope">
                                    <el-form-item class="no-label" :prop="'tableData.' + scope.$index + '.customerRemark'">
                                        <div class="" style="padding-right: 17px">
                                            <el-input v-model="scope.row.customerRemark" size="small" type="textarea" :rows="5"></el-input>
                                        </div>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                        </lx-table>
                    </el-form>

                    <div class="addOrder-btn-container lx-flex-row-between">
                        <div class="lx-flex-shrink-0 lx-flex-row">
                            <el-checkbox v-model="isCheckedAll" @change="onChangeSelectAll(isCheckedAll)" style="margin:0 20px">{{ $t('cart.cart7') }}</el-checkbox>
                            <el-button @click="deleteRow()" icon="el-icon-minus" class="form-btn btn-red">{{ $t('createOrder.batchDelete') }}({{selectNum}})</el-button>
                            <el-button @click="addRow()" icon="el-icon-plus" class="form-btn btn-green">{{ $t('createOrder.createOrder36') }}</el-button>
                        </div>
                        <div class="lx-flex-grow-1 lx-flex-row lx-ml16 lx-mr16">
                            <span class="lx-flex-1">{{ $t('cart.cart1') }}：{{ totalCount }}</span>
                            <span class="lx-flex-1">{{ $t('cart.cart2') }}：{{ totalPrice }}{{$t('orderList.orderList121')}}</span>
                            <span class="lx-flex-1">{{ $t('cart.cart3') }}：{{ selectedPrice }}{{$t('orderList.orderList121')}}</span>
                            <span class="lx-flex-1">{{ $t('cart.cart5') }}：{{ oldSaveTime | dateFormatToSecond | empty }}</span>
                        </div>
                        <div class="lx-flex-shrink-0 lx-flex-row">
                            <el-button class="lx-flex-shrink-0" @click="submitOrder" type="primary" style="width: 130px">{{ $t('submitOrder') }}{{ `(${selectNum})` }}</el-button>
                            <el-button class="lx-flex-shrink-0" @click="saveForm(metaTableList)" type="warning" style="width: 130px">{{ $t('baoc') }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </full-con>

        <!-- 联系我们 -->
        <MessageTip :visiable.sync="isVisiable" :title="$t('createOrder.createOrder101')" :userName="userInfo.userName" :messageType="$t('createOrder.createOrder110')" httpUrl="cmUser/message/sendMessage" @confirm="isVisiable = false"></MessageTip>

        <!--商品详情 -->
        <el-dialog :title="$t('menu.menu5')" :visible.sync="goodsDialogVisible" width="80%" @close="goodsDialog">
            <div class="product-detail">
                <div class="intro-container overflow">
                <div class="picture-container left">
                    <div class="top-img">
                    <div class="lg-img">
                        <img v-if="SelectedAttrImgUrl.length > 0" :src="SelectedAttrImgUrl" alt="" />
                        <img v-else src="@/assets/images/default.png" alt="" />
                    </div>
                    </div>
                </div>
                <div class="attr-container left">
                    <el-form label-width="66px" ref="productDetailForm" :model="productForm">
                    <div class="name-container">
                        {{ productName }}
                    </div>
                    <div class="price-container">
                        <el-form-item :label="$t('createOrder.createOrder37')">
                        <el-input size="small" v-model="productForm.skuPrice"></el-input>
                        </el-form-item>
                    </div>
                    <div class="specification-container">
                        <div class="attr-row overflow" v-for="(item, index) in specificationList" :key="index">
                        <div class="title left" style="height: 30px; line-height: 30px">{{ item.name }}:</div>
                        <div :class="item2.checked == '1' ? 'attr-tag left attr-tag-checked' : 'attr-tag left attr-tag'"
                            v-for="(item2, index2) in item.value" @click="tagClick(item2, item)" :key="index2">
                            {{ item2.name }}
                        </div>
                        </div>
                    </div>
                    <div class="stock-container">
                        <el-form-item :label="$t('createOrder.createOrder38')">
                        <el-input-number controls-position="right" :min="0" v-model="productForm.quantity" size="small"
                            onkeyup="this.value.replace(/\|D^0/g,'')"> </el-input-number>
                        </el-form-item>
                    </div>
                    </el-form>
                </div>
                </div>
                <div class="detail-container"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="form-btn btn-gray" @click="goodsCancel">{{ $t('cancel') }}</el-button>
                <el-button class="form-btn btn-blue" @click="goodsSave">{{ $t('confirm') }}</el-button>
            </span>
        </el-dialog>

      <!-- 选择地址 -->
      <el-dialog width="978px" :visible.sync="maskShow" center :show-close="false" class="addrescancel">
        <subAddress style="width: 100%" ref="subAddress" :key="Math.random()" @onCancel="handleAddressCancel" @update:show="handleAddressCancel" @onChange="handleAddressChange" />
      </el-dialog>
    </div>
</template>

<script>
import subAddress from './cmp/subAddress.vue'
import MessageTip from './cmp/MessageTip'
import BatchUpload from './cmp/BatchUpload'
import LxTable from '@/components/LxTable'
import Oss from '@/assets/js/oss.js';
import { onBeforeunload, closeBeforeunload, throttle } from '@/assets/js/utils'

const defaultCheck = ['baseCheck'] // 默认检品选项
const formData = {
    id: null,
    trackingNumber: '', // 国内运单号
    taobaoUrl: '', // 商品链接
    goodsName: '', // 名称
    goodsCount: '', // 数量
    price: '', // 单价
    colour: '', // 颜色
    goodsSize: '', // 尺寸
    goodsNumber: '', // sku
    freightDisabled: true, // 国内运单号是否可编辑
    pictureUrl: '', // 图片
    pictureName: '',
    pdfName: '', // 文件
    pdfUrl: '',
    agentFlag: '0', // 是否代购
    // putIntent: '', // 包装意向
    orderType: '1', // FBA/YFF/ZOZO/RSL
    fnskuDisabled: false, // FBA/YFF/ZOZO/RSL 是否可选
    skuLabel: '', // fnsku的label名称
    fnsku: '', // fnsku
    goodsNameCus: '', // 品名
    asin: '', // asin
    checkProjectArray: defaultCheck, // 检品选项
    inspectionFileName: '', // 检品文件
    inspectionFileUrl: '',
    laundryLabelId: '', // 水洗标模板
    isTempDisabled: false, // 水洗标模板是否可选
    customerRemark: '', // 备注
    isChecked: false,
}

export default {
    name: "Cart",
    components: {
      subAddress,
        MessageTip,
        BatchUpload,
        LxTable
    },
    data () {
        return {
          maskShow: false,
            isSpin: true,
            userInfo: {},
            isVisiable: false,
            formData: this._.cloneDeep(formData),
            metaTableList: [], // 所有的\源数组
            tableData: [],
            rules: [],
            defaultRules: {}, // 默认校验规则
            timeOut: null,
            listQuery: {
                page: 1,
                limit: 1
            },
            everyTableLength: 500, // 列表条数界线（初始化rule使用）
            selectedList: [], // 当前已选择的
            randomKey: 'id',
            agentFlagOption: [], // 是否代购
            laundryLabelOption: [], // 水洗标模板
            fbaOption: [],  // FBA/YFF/ZOZO/RSL
            inspectionOption: [], // 检品选项

            flag: false,
            goodsDialogVisible: false,
            SelectedAttrImgUrl: '', /*右侧属性选中后显示的img*/
            productName: '', // 商品详情
            specificationList: [], // 规格
            pullSize: '',
            pullName: '',
            isInSmImg: 1,
            index: 0,
            selectedAttr: [],
            /*商品sku表*/
            productArray: [],
            productForm: {
                skuPrice: '',
                quantity: '1'
            },
            editCurRow: '',
            selectedSku: {},
            type: 0,
            item: '',
            listObj: {},
            fileListObj:{},
            pdfListObj:{},
            curRow: 0,
            curRowPDF: 0,
            curRowImg: 0,
            curRowFile: 0,
            curUploadImgArr: [],
            imgDataObj: {
                policy: '',
                signature: '',
                key: '',
                ossaccessKeyId: '',
                dir: '',
                host: '',
                timeStamp: ''
            },
            pdfFileList: [],
            pdfDataObj: {
                policy: '',
                signature: '',
                key: '',
                ossaccessKeyId: '',
                dir: '',
                host: '',
                timeStamp: ''
            },
            fileDataObj: {
                policy: '',
                signature: '',
                key: '',
                ossaccessKeyId: '',
                dir: '',
                host: '',
                timeStamp: ''
            },
            oldSaveTime: '', // 上次保存时间
            totalPrice: 0, // 购物车商品总金额
            selectedPrice: 0, // 选中订单预计金额
            isSubmit: false,
            isCheckedAll: false, // 是否全选
            scrollDom: null,
            errorOrders: [], // 错误订单
            addressIndex: 0, // 选择的地址索引
        };
    },
    computed: {
        formInfo() {
            return { tableData: this.tableData, rules: this.rules }
        },
        // 是否开启代为购买权限  0关闭 1开启
        agentFlag() {
            return this.userInfo.hotboomFlag === '1' ? '1' : '0'
        },
        // 当前选中数量
        selectNum() {
            return this.selectedList.length
        },
        // 购物车商品数量
        totalCount() {
            return this.metaTableList.length
        },
        // 加载等待时间
        loadDelay () {
            let delay = 1000
            delay = this._.multiply(this.listQuery.limit, 1000)
            return delay
        },
    },
    watch: {
        tableData(list) {
            const len = list.length
            const rLen = this.rules.length
            const distance = this.everyTableLength > 100 ? 100 : this.everyTableLength
            if (((len < rLen) && (len > (rLen - distance))) || len > rLen) {
                this.initRules() // 添加校验规则
            }
        },
        selectedList: {
            handler() {
                if((this.metaTableList.length === this.selectedList.length)&&this.selectedList.length!==0){
                    this.isCheckedAll = true
                } else {
                    this.isCheckedAll = false
                }
            }
        },
    },
    created() {
        this.initRules()
        this.getUserInfo()
        this.initData()
        this.getOldSaveTime()
    },
    mounted() {
        this.onTableScroll()
        onBeforeunload()
    },
    destroyed() {
        this.scrollDom.removeEventListener('scroll', this.scrollLoadMore);
    },
    beforeRouteLeave(to, form, next) {
        if (form.name === 'Cart' && !this.isSubmit) {
            this.$confirm(this.$t('cart.cart4'), {
                confirmButtonText: this.$t('cart.cart10'),
                confirmButtonClass: 'form-btn btn-blue',
                cancelButtonText: this.$t('cart.cart11'),
                cancelButtonClass: 'form-btn btn-gray',
                showClose: false,
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false
            })
            .then(() => {
                this.isSubmit = false
                next()
                closeBeforeunload();
                this.saveForm(this.metaTableList)
            }).catch(() => {
                this.isSubmit = false
                next()
                closeBeforeunload();
            })
        } else {
            next()
        }
    },
    methods: {
      // 选择收货地址
      selectAddress(row,index) {
        this.addressIndex = index
        this.maskShow = true;
      },
      // 选择收货地址弹窗确认回掉
      handleAddressChange(addressData) {
        console.log("选中的地址数据:", addressData);
        this.tableData = this.tableData.map((item,index) => {
          if(index === this.addressIndex) {
            item.address = addressData.receiverName
            item.addressId = addressData.id
          }
          return { ...item }
        })
        // 更新表单中的收货人信息
        // this.ruleForm.receiver = `${addressData.receiverName || ''}`.trim();
        // this.ruleForm.receiverConfigAddressInfoId = `${addressData.id || ''}`;
        // 关闭地址选择对话框
        this.maskShow = false;
      },
      // 选择收货地址弹窗关闭
      handleAddressCancel() {
        this.maskShow = false;
      },
        // 初始化数据（默认数据放这里初始化）
        initData() {
            const fbaOption = [
                {
                    label: this.$t('running.suspended0'),
                    value: '1'
                },
                {
                    label: 'FBA',
                    value: '0'
                },
                {
                    label: 'YFF',
                    value: '2'
                },
                {
                    label: 'ZOZO',
                    value: '3'
                },
                {
                    label: 'RSL',
                    value: '4'
                },
              /*{
                label: 'mercari',
                value: '5'
              },
              {
                label: 'rakuma',
                value: '6'
              },*/
            ]
            const agentFlagOption = [
                {
                    label: this.$t('running.suspended1'),
                    value: '1'
                },
                {
                    label: this.$t('running.suspended0'),
                    value: '0'
                }
            ]
            this.fbaOption = fbaOption
            this.agentFlagOption = agentFlagOption
            Promise.all([this.getInspectionOption(), this.getCartList(), this.getLaundryLabelOption()]).then(data => {
                this.inspectionOption = data[0];
                let tableData = data[1]
                this.laundryLabelOption = data[2];
                if(tableData.length > 0) {
                    this.initRender(tableData)
                } else {
                    this.isSpin = false
                }
            })
        },
        // 初始化页面
        initRender() {
            if (this.metaTableList.length > 0) this.lazyLoad()
            if (this.metaTableList.length > 1) {
                this.$nextTick(() => {
                    this.lazyLoad()
                    if (this.metaTableList.length > 2) {
                        this.$nextTick(() => {
                            this.lazyLoad()
                        })
                    }
                })
            }
            this.loadEnd()
        },
        // 监听table滚动
        onTableScroll() {
            this.scrollDom = document.querySelector('.el-table__body-wrapper');
            this.scrollDom.addEventListener('scroll', this.scrollLoadMore);
        },
        /**
         * 监听滚动条
         * scrollTop为滚动条在Y轴上的滚动距离。
         * scrollHeight为内容可视区域的高度加上溢出（滚动）的距离。
         * clientHeight为内容滚动区域的高度。
        * */
        scrollLoadMore: throttle(function () {
            let scrollWrap = document.querySelector ('.el-table__body-wrapper');
            let currentScrollTop = scrollWrap.scrollTop;
            let currentOffsetHeight = scrollWrap.scrollHeight;
            let currentClientHeight = scrollWrap.clientHeight;
            if (((this._.add(currentClientHeight, currentScrollTop) === currentOffsetHeight) || ( 0.5 >= this._.subtract(this._.add(currentClientHeight, currentScrollTop), currentOffsetHeight) > 0)) && ((this.tableData&&this.metaTableList) && (this.tableData.length <= this.metaTableList.length))) {
                // this.isSpin = true
                // this.listQuery.page++
                this.lazyLoad(this.listQuery.page)
                // this.loadEnd()
            }
        }, 300),
        // 数据懒加载
        lazyLoad() {
            const limit = this.listQuery.limit
            const beginIndex = this.tableData.length
            const endIndex =  this._.add(beginIndex, limit)
            let waitAddList = this.metaTableList.slice(beginIndex, endIndex)
            waitAddList.forEach(item => {
                this.renderItemInfo(item)
            })
            this.tableData = this.tableData.concat(waitAddList)
        },

        // 新增/批量导入时数据初始化
        renderItemInfo(row) {
            const index = this.metaTableList.findIndex(item => item.id === row.id)
            // 代购权限
            if (!row.agentFlag) {
                row.agentFlag = this.agentFlag
                this.$set(row, 'freightDisabled', row.agentFlag === '1' ? false : true);
            } else if (row.agentFlag === '1') {
                this.$set(row, 'freightDisabled', false);
            } else if (row.agentFlag === '0') {
                this.$set(row, 'freightDisabled', true);
            }
            // 类型FBA/YFF/ZOZO/RSL
            if (row.orderType === '1' || row.orderType == null || row.orderType == undefined) {
                row.fnsku = '';
                row.goodsNameCus = '';
                row.asin = ''
                this.$set(row, 'fnskuDisabled', false);
            } else {
                if(row.orderType === '0') {
                    this.rules[index].skuLabel = 'FNSKU';
                    this.rules[index].skuPlaceolder = 'X00000001';
                    this.$set(row, 'skuPlaceolder', 'X00000001');
                    this.$set(row, 'skuLabel', 'FNSKU');
                } else if (row.orderType === '2') {
                    this.rules[index].skuLabel = 'YFFコード';
                    this.rules[index].skuPlaceolder = 'hello-red';
                    this.$set(row, 'skuPlaceolder', 'hello-red');
                    this.$set(row, 'skuLabel', 'YFFコード');
                } else if (row.orderType === '3') {
                    this.rules[index].skuLabel = 'ZOZOコード';
                    this.rules[index].skuPlaceolder = 'ICH123456789';
                    this.$set(row, 'skuPlaceolder', 'ICH123456789');
                    this.$set(row, 'skuLabel', 'ZOZOコード');
                } else if (row.orderType === '4') {
                    this.rules[index].skuLabel = 'JANコード';
                    this.rules[index].skuPlaceolder = '123456789';
                    this.$set(row, 'skuPlaceolder', '123456789');
                    this.$set(row, 'skuLabel', 'JANコード');
                }
                this.rules[index].fnsku[0].required = true
                this.rules[index].goodsNameCus[0].required = true
                this.$set(row, 'fnskuDisabled', true);
            }
            if(row.checkProjectArray && row.checkProjectArray.length > 0){
                row.checkProjectArray.forEach(item=>{
                    if(item === 'laundryLabel'){
                        this.rules[index].laundryLabelId[0].required = true
                        this.$set(row, 'isTempDisabled', true);
                    }
                })
            } else {
                row.checkProjectArray = defaultCheck
            }
        },

        // 加载效果
        loadEnd() {
            if (this.timeOut) {
                clearTimeout(this.timeOut)
            }
            this.timeOut = setTimeout(() => {
                this.isSpin = false
            }, this.loadDelay);
        },

        // 初始化校验规则
        initRules() {
            this.defaultRules = {
                trackingNumber: [
                    {
                        required: this.agentFlag === '1' ? false : true,
                        message: this.$t('createOrder.createOrder62'),
                        trigger: 'blur'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]+$/,
                        message: this.$t('createOrder.createOrder63'),
                        trigger: 'blur'
                    }
                ],
                goodsCount: [
                    {
                        required: true,
                        message: this.$t('createOrder.createOrder47'),
                        trigger: 'blur'
                    },
                    {
                        pattern: /^[1-9]\d*$/,
                        message: this.$t('createOrder.createOrder48'),
                        trigger: 'blur'
                    }
                ],
                price: [
                    {
                        required: true,
                        message: this.$t('createOrder.createOrder82'),
                        trigger: 'blur'
                    },
                    {
                        pattern: /(^(([1-9]([0-9]+)?)|(0{1}))(\.[0-9]{1,2})?$)/,
                        message: this.$t('createOrder.createOrder49'),
                        trigger: 'blur'
                    }
                ],
                colour: [
                    {
                        required: true,
                        message: this.$t('createOrder.createOrder81'),
                        trigger: 'blur'
                    }
                ],
                fnsku: [
                    {
                        required: false,
                        message: this.$t('createOrder.createOrder84'),
                        trigger: 'blur'
                    }
                ],
                goodsNameCus: [
                    {
                        required: false,
                        message: this.$t('createOrder.createOrder84'),
                        trigger: 'blur'
                    }
                ],
                laundryLabelId: [
                    {
                    required: false,
                    message: this.$t('createOrder.createOrder87'),
                    trigger: 'blur'
                    }
                ],
              tongkun: [
                {
                  required: true,
                  message: '请选择是否同捆',
                  trigger: 'blur'
                }
              ],
              address: [
                {
                  required: this,
                  message: '请选择收货地址',
                  trigger: 'blur'
                }
              ],
            }
            for (let index = 0; index < this.everyTableLength; index++) {
                this.rules.push(this.defaultRules)
            }
        },
        async getUserInfo () {
            const { data: res } = await this.$http.get('customer/getCustomerInfo');
            this.userInfo = res.data;
        },
        // 充值
        toRecharge() {
            this.$router.push({ name: 'recharge' });
        },
        // 批量导入
        onBatchImport() {
            closeBeforeunload();
            this.isSpin = true
            // this.tableData = this.tableData.concat(list) // 一次性导入渲染变慢
            // this.getCartList().then(() => {
            //     this.initRender()
            // })
            this.$router.go(0)
        },
        // 删除订单
        doDelete (row) {
            const idList = [row.id]
            const url = `shopping/vehicle/delete/${row.id}`
            this.$http.post(url).then(() => {
                this.deleteResetFn(idList)
                this.$message.success(this.$t('success'))
            })
        },
        // 复制
        doCopy(row) {
            const oldRow = this._.cloneDeep(row)
            const url = `shopping/vehicle/copy/${row.id}`
            this.$http.post(url).then((res) => {
                const newRow = res.data.data
                oldRow.id = newRow.id
                oldRow.isChecked = this.isCheckedAll
                oldRow.trackingNumber = ''
                this.tableData.unshift(oldRow)
                this.metaTableList.unshift(oldRow)
                if (this.isCheckedAll) this.getPayNum(this.selectedList, 'selected')
                this.getPayNum(this.metaTableList, 'all')
            })
        },
        // 计算价格用
        onInputChange() {
            if (this.selectedList.length > 0) this.getPayNum(this.selectedList, 'selected')
            else this.selectedPrice = 0
            if (this.metaTableList.length > 0) this.getPayNum(this.metaTableList, 'all')
            else this.totalPrice = 0
        },
        // 商品链接
        async blurTaobaoUrl (url, index) {
            if (this.flag == false) {
                if (url.length > 0) {
                this.SelectedAttrImgUrl = '';
                let _this = this;
                const { data: res } = await this.$http.get('order/getGoodsInfo', { params: { url: url } });
                if (res.code != '200') {
                    this.$message.error(res.message);
                } else {
                    this.goodsDialogVisible = true;
                    this.flag = true
                    this.productName = res.data.title;
                    // this.getData();
                    this.specificationList = res.data.specificationList;
                    _this.pullSize = this.specificationList.some((item) => item.colorFlag == 0)
                    ? this.specificationList.find((item) => item.colorFlag == 0).name
                    : this.specificationList.some((item) => item.colorFlag == 2)
                        ? this.specificationList.find((item) => item.colorFlag == 2).name
                        : '';
                    _this.pullName = this.specificationList.some((item) => item.colorFlag == 1)
                    ? this.specificationList.find((item) => item.colorFlag == 1).name
                    : this.specificationList.some((item) => item.colorFlag == 2)
                        ? this.specificationList.find((item) => item.colorFlag == 2).name
                        : '';
                    this.specificationList.forEach((el) => {
                    el.value.forEach((el2) => {
                        _this.$set(el2, 'checked', '0');
                    });
                    });
                    this.productArray = res.data.skuList;
                    _this.SelectedAttrImgUrl = res.data.picUrl
                }
                this.editCurRow = index;
                }
            }
        },
        // 拉取得商品详情关闭弹框回调
        goodsDialog () {
            this.productForm.skuPrice = '';
            this.$set(this.productForm, 'quantity', '1');
            if (this.selectedSku.properties_name) {
                this.selectedSku.properties_name = []
            }
            this.specificationList = ''
            this.flag = false
        },
        // 模板下载
        downloadTemplate() {
          window.open('https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/oytqc/instructions/template.xlsm', "_blank");
            // let url = 'api/order/downloadTemplateAction'; // 请求的url + id
            // let xhr = new XMLHttpRequest();
            // xhr.open('GET', url, true);
            // xhr.responseType = 'blob';
            // xhr.setRequestHeader('client_type', 'DESKTOP_WEB');
            // xhr.setRequestHeader('Authorization', window.sessionStorage.getItem('token')); // 自定义请求头
            // xhr.onload = function () {
            //     if (this.status == 200) {
          //     let blob = this.response;
          //     let fileName = 'template.xlsx';
          //     if (window.navigator.msSaveOrOpenBlob) {
          //         // IE浏览器下
          //         navigator.msSaveBlob(blob, fileName);
          //     } else {
          //         let link = document.createElement('a');
          //         link.href = window.URL.createObjectURL(blob);
          //         link.download = fileName;
          //         link.click();
          //         window.URL.revokeObjectURL(link.href);
          //     }
          //     }
          // };
          // xhr.send();
        },
        //上传图片
        uploadImg (file) {
            let _self = this;
            const isJPG = file.file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
            if (!isJPG) {
                _self.$message.error(this.$t('createOrder.createOrder74'));
                return;
            }
            let formdata = new FormData();
            formdata.append('file', file.file);
            formdata.append('modular', 'createOrder');
            formdata.append('fileType', '');
            _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
                if (res.data.code == 200) {
                _self.tableData[this.curRowImg].pictureUrl = res.data.data;
                _self.tableData[this.curRowImg].pictureName = res.data.data.split('createOrder/')[1];
                _self.$message.success(this.$t('createOrder.createOrder73'));
                } else {
                _self.$message.error(this.$t('createOrder.createOrder75'));
                }
            });
        },

        //----- 商品详情相关start--------
        beforeImgUpload (file) {
            const _self = this;
            const fileName = file.uid;
            this.listObj[fileName] = {};
            return new Promise((resolve, reject) => {
                _self.$http
                .get('aliyun/oss/policy')
                .then((response) => {
                    var num = ''; //定义编号
                    for (
                    var i = 0;
                    i < 4;
                    i++ //4位随机数，用以加在时间戳后面。
                    ) {
                    num += Math.floor(Math.random() * 10);
                    }
                    num = new Date().getTime() + num; //时间戳，用来生成编号。
                    _self.imgDataObj.policy = response.data.data.policy;
                    _self.imgDataObj.signature = response.data.data.signature;
                    _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
                    _self.imgDataObj.key = response.data.data.dir + '/order/' + num + '${filename}';
                    _self.imgDataObj.dir = response.data.data.dir + '/order';
                    _self.imgDataObj.host = response.data.data.host;
                    _self.imgDataObj.timeStamp = num;
                    file.timeStamp = num
                    Oss.imgCompress(file, this.listObj, resolve, reject);
                })
                .catch(() => {
                    reject(false);
                });
            });
        },
        goodsCancel () {
            this.$refs.productDetailForm.resetFields();
            this.goodsDialogVisible = false;
        },
        // 商品信息保存
        async goodsSave () {
            const goodsInfo = {
                goodsName: this.productName,
                goodsSize: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullSize) ? this.selectedSku.properties_name.find(item => item.name == this.pullSize).value : '',
                colour: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullName) ? this.selectedSku.properties_name.find(item => item.name == this.pullName).value : '',
                goodsCount: this.productForm.quantity,
                price: this.productForm.skuPrice,
                pictureUrl: this.SelectedAttrImgUrl
            }
            let params = {}
            Object.assign(params, this.tableData[this.editCurRow], goodsInfo)
            const { data } = await this.$http.post('shopping/vehicle/update', params)
            if (data.code === 200) {
                Object.assign(this.tableData[this.editCurRow], data.data)
                this.renderItemInfo(this.tableData[this.editCurRow])
                this.goodsDialogVisible = false;
            } else {
                this.$message.error(data.message)
            }
        },
        tagClick (item2, item) {
            if (item.colorcolorFlag == '1') {
                this.isInSmImg = 0;
            }
            item.value.forEach(function (el) {
                el.checked = '0';
            });
            item2.checked = '1';
            //选择颜色，左侧图片联动
            if (item2.url) {
                this.SelectedAttrImgUrl = item2.url;
            }
            this.getSku();
        },
        getSku () {
            let selectskuattrs = [];
            let attrCount = this.specificationList.length;
            let selectAttrCount = 0;
            this.specificationList.forEach(function (el) {
                el.value.forEach(function (el2) {
                if (el2.checked == '1') {
                    selectAttrCount++;
                    selectskuattrs.push({
                    name: el.name,
                    value: el2.name
                    });
                }
                });
            });
            var _this = this;
            if (attrCount == selectAttrCount) {
              //是否可选
              let isSelect = false
                this.productArray.forEach(function (el) {
                  let properties = [...el.properties_name]
                  let selectsku = [...selectskuattrs]
                  properties.sort((a, b) => a.name.localeCompare(b.name));
                  selectsku.sort((a, b) => a.name.localeCompare(b.name));
                  if (JSON.stringify(properties) === JSON.stringify(selectsku)) {
                    isSelect = true
                    _this.selectedSku = el;
                    _this.productForm.skuPrice = el.price;
                    //_this.productForm.quantity = el.quantity;
                }
                });

              if (!isSelect){
                _this.selectedSku = {}
                _this.productForm.skuPrice = ''
              }
            }
        },
        //----- 商品详情相关end--------

        beforeUploadImg (index) {
            this.curRowImg = index;
        },
        beforeUploadVideo (index) {
            this.curRowPDF = index;
        },
        beforeUploadFile (index) {
            this.curRowFile = index;
        },
        delPdf (row) {
            this.$confirm(this.$t('createOrder.createOrder68'), {
                confirmButtonText: this.$t('submit'),
                confirmButtonClass: 'form-btn btn-blue',
                cancelButtonText: this.$t('cancel'),
                cancelButtonClass: 'form-btn btn-gray'
            })
            .then(() => {
                row.pdfName = '';
                row.pdfUrl = '';
                this.$message({
                    type: 'success',
                    message: this.$t('createOrder.createOrder69')
                });
            })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('createOrder.createOrder70')
                });
            });
        },
        delFile (row) {
            this.$confirm(this.$t('createOrder.createOrder68'), {
                confirmButtonText: this.$t('submit'),
                confirmButtonClass: 'form-btn btn-blue',
                cancelButtonText: this.$t('cancel'),
                cancelButtonClass: 'form-btn btn-gray'
            })
            .then(() => {
                row.inspectionFileName = '';
                row.inspectionFileUrl = '';
                this.$message({
                    type: 'success',
                    message: this.$t('createOrder.createOrder69')
                });
            })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('createOrder.createOrder70')
                });
            });
        },
        async delImg (row, index) {
            this.$confirm(this.$t('createOrder.createOrder71'), {
                confirmButtonText: this.$t('submit'),
                confirmButtonClass: 'form-btn btn-blue',
                cancelButtonText: this.$t('cancel'),
                cancelButtonClass: 'form-btn btn-gray',
                type: 'warning'
            })
            .then(() => {
                this.tableData[index].pictureUrl = '';
                this.tableData[index].pictureName = '';
            })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('createOrder.createOrder70')
                });
            });
        },
        //上传pdf
        uploadVideo (file) {
            let _self = this;
            const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);
            const whiteList = ['pdf', 'ai'];
            if (whiteList.indexOf(fileSuffix) === -1) {
                // this.$message.error('上传文件只能是 pdf、ai 格式');
                _self.$message.error(this.$t('createOrder.createOrder98'));
                return;
            }
            const isLt2M = file.file.size / 1024 / 1024 < 20;
            if (!isLt2M) {
                // this.$message.error('上传文件大小不能超过 20MB');
                _self.$message.error(this.$t('createOrder.createOrder97'));
                return;
            }
            let formdata = new FormData();
            formdata.append('file', file.file);
            formdata.append('modular', 'OrderDetail');
            formdata.append('fileType', '');
            _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
                if (res.data.code == 200) {
                _self.tableData[this.curRowPDF].pdfUrl = res.data.data;
                _self.tableData[this.curRowPDF].pdfName = res.data.data.split('OrderDetail/')[1];
                _self.$message.success(this.$t('createOrder.createOrder73'));
                }
            });
        },
        beforePdfUpload (file) {
            const _self = this;
            const fileName = file.uid;
            this.pdfListObj[fileName] = {};
            return new Promise((resolve, reject) => {
                _self.$http
                .get('aliyun/oss/policy')
                .then((response) => {
                    var num = ''; //定义编号
                    for (
                    var i = 0;
                    i < 4;
                    i++ //4位随机数，用以加在时间戳后面。
                    ) {
                    num += Math.floor(Math.random() * 10);
                    }
                    num = new Date().getTime() + num; //时间戳，用来生成编号。
                    _self.pdfDataObj.policy = response.data.data.policy;
                    _self.pdfDataObj.signature = response.data.data.signature;
                    _self.pdfDataObj.ossaccessKeyId = response.data.data.accessKeyId;
                    _self.pdfDataObj.key = response.data.data.dir + '/order/' + num + file.name;
                    _self.pdfDataObj.dir = response.data.data.dir + '/order';
                    _self.pdfDataObj.host = response.data.data.host;
                    _self.pdfDataObj.timeStamp = num;
                    let arr = [
                    {
                        hasSuccess: true,
                        height: undefined,
                        uid: file.uid,
                        url: _self.pdfDataObj.host + '/' + _self.pdfDataObj.key,
                        width: undefined
                    }
                    ];
                    this.$emit('successCBK', arr);
                    this.pdfListObj = {};
                    resolve(true);
                })
                .catch(() => {
                    reject(false);
                });
            });
        },
        //上传检品文件
        uploadFile (file) {
            let _self = this;
            const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);
            const whiteList = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'jpg', 'jpeg', 'png', 'gif'];
            if (whiteList.indexOf(fileSuffix) === -1) {
                _self.$message.error(this.$t('createOrder.createOrder96'));
                return;
            }
            const isLt2M = file.file.size / 1024 / 1024 < 20;
            if (!isLt2M) {
                _self.$message.error(this.$t('createOrder.createOrder97'));
                return;
            }
            let formdata = new FormData();
            formdata.append('file', file.file);
            formdata.append('modular', 'OrderDetail');
            formdata.append('fileType', '');
            _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
                if (res.data.code == 200) {
                _self.tableData[this.curRowFile].inspectionFileUrl = res.data.data;
                _self.tableData[this.curRowFile].inspectionFileName = res.data.data.split('OrderDetail/')[1];
                _self.$message.success(this.$t('createOrder.createOrder73'));
                }
            });
        },
        agentFlagchange (type, index, row) {
            if (type == 1) {
                row.trackingNumber = ''
                this.$set(row, 'freightDisabled', false);
                this.rules[index].trackingNumber[0].required = false;
            } else {
                this.rules[index].trackingNumber[0].required = true;
                this.$set(row, 'freightDisabled', true);
            }
        },
        //选择是否fba
        orderTypeChange (val, index, row) {
            if (val == 1) {
                this.rules[index].fnsku[0].required = false;
                row.fnsku = '';
                row.goodsNameCus = '';
                this.$set(row, 'fnskuDisabled', false);
            } else {
                this.rules[index].fnsku[0].required = true;
                this.rules[index].goodsNameCus[0].required = true;
                this.$set(row, 'fnskuDisabled', true);
            }
            if (val == 1) {
                this.rules[index].skuLabel = 'コード';
                this.$set(row, 'skuLabel', 'コード');
                this.rules[index].skuPlaceolder = '';
                this.$set(row, 'skuPlaceolder', '');
            }
            if (val == 0) {
                this.rules[index].skuLabel = 'FNSKU';
                this.rules[index].skuPlaceolder = 'X00000001';
                this.$set(row, 'skuPlaceolder', 'X00000001');
                this.$set(row, 'skuLabel', 'FNSKU');
            }
            if (val == 2) {
                this.rules[index].skuLabel = 'YFFコード';
                this.rules[index].skuPlaceolder = 'hello-red';
                this.$set(row, 'skuPlaceolder', 'hello-red');
                this.$set(row, 'skuLabel', 'YFFコード');
            }
            if (val == 3) {
                this.rules[index].skuLabel = 'ZOZOコード';
                this.rules[index].skuPlaceolder = 'ICH123456789';
                this.$set(row, 'skuPlaceolder', 'ICH123456789');
                this.$set(row, 'skuLabel', 'ZOZOコード');
            }
            if (val == 4) {
                this.rules[index].skuLabel = 'JANコード';
                this.rules[index].skuPlaceolder = '123456789';
                this.$set(row, 'skuPlaceolder', '123456789');
                this.$set(row, 'skuLabel', 'JANコード');
            }
            if (this.selectedList.some(item => item.id === row.id)) {
                // 解决全选后change数据不响应的问题
                this.selectedList.find(item => item.id === row.id).orderType = val
            }
            this.$nextTick(() => {
                this.$refs.addForm.clearValidate();
            });
        },
        // 检品选项选择改变时
        configCheckChanged (row) {
            const index = this.metaTableList.findIndex(item => item.id === row.id)
            if (row.checkProjectArray.length === 0) {
                row.checkProjectArray = defaultCheck
            }
            if (row.checkProjectArray.includes('laundryLabel')) {
                this.$set(row, 'isTempDisabled', true);
                this.rules[index].laundryLabelId[0].required = true
            } else {
                row.laundryLabelId = '';
                this.$set(row, 'isTempDisabled', false);
                this.rules[index].laundryLabelId[0].required = false
            }
            if (this.selectedList.length > 0) this.getPayNum(this.selectedList, 'selected')
            else this.selectedPrice = 0
            if (this.metaTableList.length > 0) this.getPayNum(this.metaTableList, 'all')
            else this.totalPrice = 0
        },
        beforeFileUpload (file) {
            const _self = this;
            const fileName = file.uid;
            this.fileListObj[fileName] = {};
            return new Promise((resolve, reject) => {
                _self.$http
                .get('aliyun/oss/policy')
                .then((response) => {
                    var num = ''; //定义编号
                    for (
                    var i = 0;
                    i < 4;
                    i++ //4位随机数，用以加在时间戳后面。
                    ) {
                    num += Math.floor(Math.random() * 10);
                    }
                    num = new Date().getTime() + num; //时间戳，用来生成编号。
                    _self.fileDataObj.policy = response.data.data.policy;
                    _self.fileDataObj.signature = response.data.data.signature;
                    _self.fileDataObj.ossaccessKeyId = response.data.data.accessKeyId;
                    _self.fileDataObj.key = response.data.data.dir + '/order/' + num + file.name;
                    _self.fileDataObj.dir = response.data.data.dir + '/order';
                    _self.fileDataObj.host = response.data.data.host;
                    _self.fileDataObj.timeStamp = num;
                    let arr = [
                    {
                        hasSuccess: true,
                        height: undefined,
                        uid: file.uid,
                        url: _self.fileDataObj.host + '/' + _self.fileDataObj.key,
                        width: undefined
                    }
                    ];
                    this.$emit('successCBK', arr);
                    this.fileListObj = {};
                    resolve(true);
                })
                .catch(() => {
                    reject(false);
                });
            });
        },

        // 购物车提交订单
        submitOrder () {
            const selectedList = this._.cloneDeep(this.selectedList)
            if (this.selectedList.length > 0) {
                let validateFieldArrs = [], valids = [], errorOrders = []
                selectedList.forEach((citem, idx) => {
                    const index = this.tableData.findIndex(item => item.id === citem.id)
                    validateFieldArrs.push(`tableData.${index}.goodsCount`)
                    validateFieldArrs.push(`tableData.${index}.price`)
                    validateFieldArrs.push(`tableData.${index}.colour`)
                    validateFieldArrs.push(`tableData.${index}.address`)
                    validateFieldArrs.push(`tableData.${index}.tongkun`)
                    if (citem.agentFlag === '0') validateFieldArrs.push(`tableData.${index}.trackingNumber`)
                    if (citem.orderType !== '1') validateFieldArrs.push(`tableData.${index}.fnsku`)
                    if (citem.orderType !== '1') validateFieldArrs.push(`tableData.${index}.goodsNameCus`)
                    if (citem.checkProjectArray && citem.checkProjectArray.includes('laundryLabel')) validateFieldArrs.push(`tableData.${index}.laundryLabelId`)
                    if (!citem.goodsCount || !citem.price || !citem.colour || (citem.agentFlag === '0' ? !citem.trackingNumber : false) || (citem.orderType !== '1' ? !citem.fnsku:false) || (citem.orderType !== '1'?!citem.goodsNameCus:false) || !citem.checkProjectArray) {
                        errorOrders.push(index + 1)
                    }
                    valids.push(!!citem.goodsCount, !!citem.price, !!citem.colour, citem.agentFlag === '0' ? !!citem.trackingNumber : true, citem.orderType !== '1' ? !!citem.fnsku:true, citem.orderType !== '1'?!!citem.goodsNameCus:true, !citem.checkProjectArray || citem.checkProjectArray.includes('laundryLabel')? !!citem.laundryLabelId:true)
                })
                this.errorOrders = errorOrders // 校验未通过的订单
                this.$refs.addForm.validateField(validateFieldArrs)
                    if (!valids.includes(false)) {
                        this.$confirm(this.$t('cart.cart12'), this.$t('prompt.title'), {
                        confirmButtonText: this.$t('submit'),
                        confirmButtonClass: 'form-btn btn-blue',
                        cancelButtonText: this.$t('cancel'),
                        cancelButtonClass: 'form-btn btn-gray',
                        type: 'warning'
                    }).then(() => {
                        this.saveForm(this.selectedList).then((ids) => {
                            this.postOrderForm(ids);
                        })
                    })
                } else {
                    this.$message.error(`${this.$t('cart.cart8')}【${this.errorOrders.join()}】${this.$t('cart.cart9')}`)
                }
            } else {
                this.$message.error(this.$t('orderList.orderList125'))
            }
        },
        postOrderForm() {
            const params = {
                idList: this.selectedList.map(item => item.id)
            }
            this.$http.post('shopping/vehicle/createOrder', params).then((res) => {
                if (res.data.code === 200) {
                    this.isSubmit = true
                    closeBeforeunload()
                    this.resetMetaTableList()
                    this.$message.success(this.$t('success'))
                    this.$nextTick(() => {
                        this.$router.push({name: 'orderList'});
                    })
                } else {
                    this.$message.error(res.data.message)
                }
            });
        },

        // 购物车保存
        saveForm (list) {
            return new Promise( (resolve, reject) => {
                if (list.length > 0) {
                    this.$http.post('shopping/vehicle/save', {
                        orderListStr: JSON.stringify(list)
                    }).then(res => {
                        if (res.data.code == 200) {
                            resolve(res.data.data)
                        } else {
                            this.$message.error(res.data.message);
                            reject()
                        }
                    });
                }
            })
        },

        // 新增一行
        addRow() {
            const row = this._.cloneDeep(formData)
            const url = 'shopping/vehicle/addOne'
            this.$http.post(url).then((res) => {
                row.id = res.data.data.id
                row.freightDisabled = this.agentFlag === '1' ? false : true
                row.agentFlag = this.agentFlag
                row.isChecked = this.isCheckedAll
                this.tableData.unshift(row)
                this.metaTableList.unshift(row)
            })
        },
        // 批量删除
        deleteRow() {
            if(this.selectNum) {
                this.$confirm(this.$t('createOrder.confirmDelete'), this.$t('prompt.title'), {
                    confirmButtonText: this.$t('submit'),
                    confirmButtonClass: 'form-btn btn-blue',
                    cancelButtonText: this.$t('cancel'),
                    cancelButtonClass: 'form-btn btn-gray',
                    type: 'warning'
                })
                .then(() => {
                    const idList = this.selectedList.map(item => item.id)
                    const url = 'shopping/vehicle/batch/delete'
                    const params = {
                        idList
                    }
                    this.$http.post(url, params).then(() => {
                        this.selectedList = []
                        this.$message.success(this.$t('success'))
                        this.deleteResetFn(idList)
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('createOrder.createOrder70')
                    });
                });
            }
        },

        // 删除操作执行
        deleteResetFn(idList) {
            const metaTableList = this._.cloneDeep(this.metaTableList)
            const tableData = this._.cloneDeep(this.tableData)
            const selectedList = this._.cloneDeep(this.selectedList)
            this.metaTableList = metaTableList.filter(item => !idList.includes(item.id))
            this.tableData = tableData.filter(item => !idList.includes(item.id))
            this.selectedList = selectedList.filter(item => !idList.includes(item.id))
            for (let i=0; i< this.rules.length; i++){
                if (idList.includes(this.rules[i].id)){
                    this.rules.splice(i, 1)
                    i--
                }
            }
            this.$nextTick(() => {
                this.initRender()
                if (this.selectedList.length > 0) this.getPayNum(this.selectedList, 'selected')
                else this.selectedPrice = 0
                if (this.metaTableList.length > 0) this.getPayNum(this.metaTableList, 'all')
                else this.totalPrice = 0
            })
        },

        // 全选监听
        onChangeSelectAll(isCheck) {
            this.isCheckedAll = isCheck
            this.metaTableList.forEach(item => {
                this.$set(item, 'isChecked', isCheck)
            })
            this.tableData.forEach((item) => {
                this.$set(item, 'isChecked', isCheck)
            })
            this.selectedList = isCheck ? this.metaTableList : []
            if (isCheck) this.getPayNum(this.metaTableList, 'selected')
            else this.selectedPrice = 0
        },

        // 多选监听
        doSelectionChange(row) {
            let selectedList = this.selectedList
            if (selectedList.length === 0) {
                this.$set(row,'isChecked', true)
                this.selectedList.push(row)
            } else if (selectedList.some(item => item.id === row.id)) {
                this.$set(row,'isChecked', false)
                const index = selectedList.findIndex(item => item.id === row.id)
                this.selectedList.splice(index, 1)
            } else {
                this.$set(row,'isChecked', true)
                this.selectedList.push(row)
            }
            if (this.selectedList.length > 0) this.getPayNum(this.selectedList, 'selected')
            else this.selectedPrice = 0
        },
        // 获取检品选项
        getInspectionOption () {
            return new Promise((resolve) => {
                this.$http.get('order/getNameList', {params: { nameClass: 'INSPECTION' }}).then(res => {
                    resolve(res.data.data)
                })
            })
        },
        // 重置源数组长度
        resetMetaTableList() {
            this.getCartList()
        },
        // 查询购物车商品
        getCartList() {
            return new Promise((resolve) => {
                this.$http.get('shopping/vehicle/query').then(res => {
                    let list = res.data.data
                    this.metaTableList = list
                    this.getPayNum(list, 'all')
                    resolve(res.data.data)
                })
            })
        },
        // 获取水洗标模板
        getLaundryLabelOption () {
            return new Promise((resolve) => {
                this.$http.get('laundry/label/template/getAll').then(res => {
                    resolve(res.data.data)
                })
            })
        },
        // 获取上次保存时间
        getOldSaveTime () {
            this.$http.get('shopping/vehicle/querySaveTime').then(res => {
                this.oldSaveTime = res.data.data
            })
        },

        // 获取预付金额
        async getPayNum (list, type) {
            const idList = list.map(item => item.id)
            await this.saveForm(list)
            this.$http.get('shopping/vehicle/queryAmountsPayable', { params: { ids: idList.join() } }).then(res => {
                const price = res.data.data
                if (type === 'all') {
                    this.totalPrice = price
                } else if (type === 'selected') {
                    this.selectedPrice = price
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
::v-deep .lx-pointer{
    width: 14px !important;
    height: 14px !important;
}
.cart-container {
    .Accessories-title {
        height: 60px;
        line-height: 60px;
        text-align: right;
        padding-right: 10px;
    }

    .Accessories {
        border-top: 1px solid #e5e9f8;
        border-right: 1px solid #e5e9f8;
    }

    .Accessories .el-col {
        height: 30px;
        line-height: 30px;
        padding: 0 2px;
        border-left: 1px solid #e5e9f8;
        border-bottom: 1px solid #e5e9f8;
        text-align: center;
        /* overflow:auto; */
    }
    .add-form /deep/ .el-form-item__label {
        text-align: left !important;
        padding: 0 5px 0 0 !important;
    }
    /deep/ .el-form-item {
        margin-bottom: 15px !important;
    }
    .add-form /deep/ .el-form-item__error {
        padding-top: 0 !important;
    }
    .add-form /deep/ .el-input--small .el-input__inner {
        padding-left: 2px !important;
    }
    .addOrder-btn-container {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 45px;
        background-color: #fff;
        box-shadow: 0 0 12px 2px rgba(0, 0, 0, .04);
        z-index: 1200;
    }
    .mini-label {
        white-space: nowrap;
    }
    .mini-label /deep/ .el-form-item__content {
        margin-left: 16px !important;
    }

    .mini-label /deep/ .el-form-item__label-wrap {
        margin-left: 0 !important;
    }
    .no-label /deep/ .el-form-item__content {
        margin-left: 0 !important;
    }
    .no-label /deep/ .el-form-item__label-wrap {
        margin-left: 0 !important;
    }
    .lx-label-ml-0 /deep/ .el-form-item__label-wrap {
        margin-left: 10px !important;
    }
    .lx-label-ml-0 /deep/ .el-form-item__content {
        margin-left: 76px !important;
    }

    ul,
    li {
    list-style: none;
    }

    .app-container {
    width: 100%;
    height: 100%;
    overflow: auto;
    }

    .left {
    float: left;
    }

    .overflow {
    overflow: hidden;
    }

    .picture-container {
    width: 40%;
    padding: 10px;
    }

    .attr-container {
    width: 60%;
    padding: 10px;
    }

    .product-detail {
    width: 100%;
    overflow: auto;
    }

    .lg-img {
    width: 230px;
    height: 230px;
    margin: 0 auto;
    }

    .lg-img img {
    width: 230px;
    height: 230px;
    }

    .bottom-img {
    width: 260px;
    margin: 10px auto 0 auto;
    overflow: hidden;
    }

    .sm-img {
    float: left;
    margin-right: 6px;
    border: 2px solid transparent;
    overflow: hidden;
    }

    .sm-img-selected {
    float: left;
    margin-right: 6px;
    border: 2px solid darkred;
    overflow: hidden;
    }

    .sm-img img {
    width: 40px;
    height: 40px;
    float: left;
    }

    .name-container {
    min-height: 21px;
    font-size: 16px;
    font-weight: 700;
    line-height: 21px;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
    }

    .tag-top {
    width: 33%;
    }

    .title-top {
    display: inline-block;
    margin-right: 6px;
    color: #6c6c6c;
    width: 70px;
    }

    .title {
    display: inline-block;
    margin-right: 6px;
    color: #6c6c6c;
    width: 66px;
    }

    .attr-tag {
    padding: 0 8px;
    border: 1px solid #ccc;
    cursor: pointer;
    margin-right: 5px;
    height: 30px;
    line-height: 30px;
    margin-top: 3px;
    }

    .attr-tag-checked {
    border: 1px solid darkred;
    color: darkred;
    }

    .attr-tag:hover {
    border: 1px solid darkred !important;
    }

    .price-container,
    .specification-container,
    .stock-container {
    margin-top: 20px;
    }

    .price-container .price,
    .price-container .act-price {
    color: red;
    font-size: 30px;
    }

    .attr-row {
    margin-top: 15px;
    }

    /* .unit{
        color: red;
        font-size: 16px;
    } */
    .product-detail /deep/ .el-form-item__label {
    text-align: left;
    }

    .upload-container .editor-slide-upload {
    margin-bottom: 20px;
    }

    .upload-demo {
    float: right;
    margin-left: 10px;
    }
    .line-height-30 /deep/ .el-form-item__content {
    line-height: 30px !important;
    }
    .style-table {
    /deep/ .el-form-item__label-wrap {
        margin-left: 0 !important;
        margin-bottom: -10px;
    }
    /deep/ .el-form-item__content {
        margin-left: 0 !important;
    }
    }


    @media screen and (min-width: 1000px) and (max-width: 1550px) {
        .row-left {
            width: 40% !important;
        }
        .row-right {
            width: 60% !important;
        }
        .search-btn {
            padding-left: 5px !important;
            padding-right: 5px !important;
        }
    }
}
.addrescancel{
  ::v-deep .el-dialog__header{
    padding: 0;
  }
}
</style>
